import Role from '../role';
import Operator from './operator';

export default class Manager extends Role {
  constructor(id) {
    super({ id, name: 'manager' });
  }

  // eslint-disable-next-line class-methods-use-this
  can(action, targetRole) {
    return ['operator', 'simplified_operator'].includes(targetRole?.name);
  }

  // eslint-disable-next-line class-methods-use-this
  assignableRoles() { return [new Operator()]; }
}
